import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Rhoi gwybod am y dudalen hon',
  title: "Rhoi gwybod am broblem gyda'r dudalen hon",
  reasons: {
    'inaccurate-or-fabricated': "Gwybodaeth anghywir neu wedi'i dyfeisio",
    'wrong-product': "Nid yw'r cynhyrchion yn cyfateb i'r dudalen",
    'sexually-explicit': 'Cynnwys rhywiol amlwg',
    'regulated-product': "Cynnyrch ar bresgripsiwn neu wedi'i reoleiddio",
    'dangerous-product': 'Cynnyrch peryglus',
    'ip-infringement': 'Yn torri fy hawliau (nod masnach/hawlfraint)',
    other: 'Rhywbeth arall',
  },
  detail: 'Manylion (dewisol)',
  submit: 'Anfon adroddiad',
  cancel: 'Canslo',
  sent: 'Diolch. Rydym yn adolygu adroddiadau o fewn 24 awr.',
  failed: "Methwyd ag anfon yr adroddiad. Ceisiwch eto, os gwelwch yn dda.",
};
